import request from './../utils/request'

// 广告请求缓存，用于合并相同参数的并发请求
const adsRequestCache = new Map()

// 缓存有效期（10秒）
const ADS_CACHE_DURATION = 10 * 1000

/**
 * 获取配置
 */
export const getConfig = () => {
  return request({
    url: '/config',
    method: 'get'
  })
}

/**
 * 获取 SEO 配置
 */
export const getSEO = () => {
  return request({
    url: '/seo',
    method: 'get'
  })
}

/**
 * 用戶信息
 */
export const getUserInfo = () => {
  return request({
    url: '/user-info',
    method: 'get'
  })
}

/**
 * 获取分享
 */
export const getShare = (params = {}) => {
  return request({
    url: '/article/share',
    method: 'get',
    params
  })
}

/**
 * 获取广告（支持请求合并，相同参数的并发请求只会发起一个实际网络请求）
 */
export const getAds = (params) => {
  // 生成唯一缓存 key，基于 position 和 adtype
  const cacheKey = `${params.position}_${params.adtype || 'default'}`

  // 检查是否有有效的缓存请求
  const cached = adsRequestCache.get(cacheKey)
  if (cached && Date.now() - cached.timestamp < ADS_CACHE_DURATION) {
    // 返回缓存的 Promise，实现请求合并
    return cached.promise
  }

  // 创建新的请求 Promise
  const promise = request({
    url: `/ads/${params.position}`,
    method: 'get',
    params
  }).finally(() => {
    // 请求完成后延迟清理缓存，允许短时间内复用
    setTimeout(() => {
      adsRequestCache.delete(cacheKey)
    }, ADS_CACHE_DURATION)
  })

  // 存入缓存
  adsRequestCache.set(cacheKey, {
    promise,
    timestamp: Date.now()
  })

  return promise
}

/**
 * 检查广告白名单
 * @param {string} creativeId - 广告素材 ID
 * @returns {Promise} 包含 is_whitelist 字段的响应
 */
export function checkAdWhitelist(creativeId) {
  return request({
    url: '/ad-whitelist/check',
    method: 'get',
    params: { creative_id: creativeId }
  })
}
